/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdDomainSettingsAdvertisementWeChatOptions, FxIdDomainSettingsAdvertisementWeChatOptionsFromJSONTyped, FxIdDomainSettingsAdvertisementWeChatOptionsToJSON, } from './FxIdDomainSettingsAdvertisementWeChatOptions';
export function FxIdDomainSettingsAdvertisementOptionsWeChatFromJSON(json) {
    return FxIdDomainSettingsAdvertisementOptionsWeChatFromJSONTyped(json, false);
}
export function FxIdDomainSettingsAdvertisementOptionsWeChatFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdDomainSettingsAdvertisementWeChatOptions(json)) {
        return FxIdDomainSettingsAdvertisementWeChatOptionsFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdDomainSettingsAdvertisementOptionsWeChatToJSON(json) {
    return FxIdDomainSettingsAdvertisementOptionsWeChatToJSONTyped(json, false);
}
export function FxIdDomainSettingsAdvertisementOptionsWeChatToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdDomainSettingsAdvertisementWeChatOptions(value)) {
        return FxIdDomainSettingsAdvertisementWeChatOptionsToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdDomainSettingsAdvertisementOptionsWeChat.js.map